module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn activity-chart"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "loader"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin fa-5x fa-fw"
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.chartsData), function(chart, i) {
    return _c('OperatorActivityChart', {
      key: i,
      attrs: {
        "title": _vm.Helper.getOperatorLogin(_vm.operators, i),
        "statistic": chart,
        "id": i
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6df214bb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/Activity.vue
// module id = 575
// module chunks = 0